export default {
  // todo add more names here over time
  ARCHIVING: 'ARCHIVING',
  INBOUND_SCRUB: 'INBOUND_SCRUB',
  OUTBOUND_SCRUB: 'OUTBOUND_SCRUB',
  SHARED_SERVICES: 'SHARED_SERVICES'
}
